import {Overlay, OverlayConfig} from '@angular/cdk/overlay';
import {DOCUMENT} from '@angular/common';
import {ChangeDetectionStrategy, Component, Inject, OnDestroy} from '@angular/core';
import {AbstractPortalToOverlayComponent} from '../../../shared/components/abstract-portal-to-overlay/abstract-portal-to-overlay.component';

@Component({
    selector: 'app-spinner-page',
    templateUrl: './spinner-page.component.html',
    styleUrls: ['./spinner-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerPageComponent extends AbstractPortalToOverlayComponent implements OnDestroy {
    constructor(overlay: Overlay, @Inject(DOCUMENT) private document: Document) {
        super(overlay);
    }

    protected createOverlayConfig(): OverlayConfig {
        const overlayConfig = super.createOverlayConfig();

        overlayConfig.hasBackdrop = true;

        return overlayConfig;
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();

        // In some way the backdrop won't be deleted completely at the staging environment (aot compiler problem?)
        // Therefore we delete it manually
        const elements = this.document.getElementsByClassName('cdk-overlay-backdrop');
        console.log('destroy spinner page, remove backdrop elements', elements);
        for (let i = 0; i < elements.length; i++) {
            const element = elements.item(i);
            console.log('backdrop element to remove:', i, element);
            element.remove();
        }
    }
}
